// constants
import { CUT_OF_DRESSES, CUT_OF_TOPS, FAVOURITE_PULLOVER, FIT_BODY_SHAPE, STYLE_PREFERENCE } from 'modules/customers/customer-edit/constants';


const StyleProfileItem = ({ field, options }) => {

    if (!field || !field.length) {
        return null;
    }

    const data = (typeof (field) === 'string' ? field?.split(',') : field) || [];

    const getClass = (option) => {
        return data.toString().toLowerCase().includes(option.toLowerCase()) ? 'is-large is-primary' : 'is-light';
    }

    return (
        <>
            {options.map((option) => (
                <span key={option} className={`tag ${getClass(option)} m-2`}>{option}</span>
            ))}
        </>
    );
};

const Profile = ({ customer }) => {

    return (
        <>
            <h1 className="title">Profile</h1>

            <div className="block">
                <h1 className="subtitle">Morphology</h1>
                <StyleProfileItem field={customer.fit_body_shape} options={FIT_BODY_SHAPE} />
            </div>
            <div className="block">
                <h1 className="subtitle">Tops</h1>
                <StyleProfileItem field={customer.cut_of_tops} options={CUT_OF_TOPS} />
            </div>
            <div className="block">
                <h1 className="subtitle">Dresses &amp; Skirts</h1>
                <StyleProfileItem field={customer.cut_of_dresses} options={CUT_OF_DRESSES} />
            </div>
            <div className="block">
                <h1 className="subtitle">Jumpers &amp; Knitwear</h1>
                <StyleProfileItem field={customer.favourite_pullover} options={FAVOURITE_PULLOVER} />
            </div>
            <div className="block">
                <h1 className="subtitle">Selected Brands</h1>
                <StyleProfileItem field={customer.style_preference} options={STYLE_PREFERENCE} />
            </div>
        </>
    );
}

export { Profile };
